import React, { Component, useEffect } from "react";
import MetaTags from 'react-meta-tags';
import { Header, SectionCareer, SectionIntro, ServicePanel } from "../../components";

import style from "./Services.module.scss";
import pattern from "../../assets/patterns/pattern03.svg";
import { useDispatch, useSelector } from 'react-redux'
import useLocale from "../../hooks/useLocale";
import { loadServicesData } from "../../store/slices/services";
import { normalizeMedia, mapSeo } from "../../api/strapi";

function HookWrapper({ render }) {
  const locale = useLocale();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadServicesData(locale));
  }, [dispatch, locale]);

  return render(loadHeader(), loadServices(), loadGlossary(), loadSeo(), locale);
}

function loadGlossary() {
  const { data } = useSelector(state => state.global)
  return (data && data.glossary) || {}
}

function loadHeader() {
  const { data } = useSelector(state => state.services)
  const page = data && data.page
  return {
    title: page && page.bannerTitle,
    caption: page && page.bannerDescription,
    image: (normalizeMedia(page && page.bannerImage) || {}).file_url,
  }
}

function loadServices() {
  const { data } = useSelector(state => state.services)
  const items = (data && data.items) || []
  return items.map(item => ({
    id: item.id,
    title: item.title,
    subtitle: item.subtitle,
    slug: item.slug,
    file: normalizeMedia(item.file) || { file_url: null },
  }))
}

function loadSeo() {
  const { data } = useSelector(state => state.services)
  return mapSeo(data && data.page && data.page.seo)
}

class Services extends Component {
  render() {
    return (
      <HookWrapper render={(props, services, glossary, seo, locale) =>
      <>
        <MetaTags>
          <title>{seo.title}</title>
          <meta name="description" content={seo.meta_description} />
          <meta name="keyword" content={seo.meta_keyword} />
          <meta property="og:title" content={seo.title} />
        </MetaTags>
        <Header />
        <SectionIntro
          title={props.title || ''}
          caption={props.caption || ''}
          image={props.image}
          pattern={pattern}
        />
        <section className={style.services__container}>
          <div className={style.services__types}>
           {
            	services.length > 0 && services.map(_el => (
               <ServicePanel
                 key={_el.id}
                 title={_el.title}
                 caption={_el.subtitle}
                 pattern={_el.file && _el.file.file_url}
                 data={services}
                 id={_el.id}
                 current_data={_el}
                 glossary={glossary}
                 locale={locale}
                 slug={_el.slug}
               />
            ))}
          </div>
        </section>
        <SectionCareer locale={locale} />
      </>
      }/>
    )
  }
}

export default Services;
